import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import React, { useState, useEffect, useRef, useMemo, useImperativeHandle } from 'react';
// import { YouTubeEmbed } from 'react-social-media-embed';
import style from './story.module.css'
import { storyTagsAtom, storyListAtom, logInfoAtom, showLoginAtom, likedStoryIdsAtom, storiesLoadedAtom, storyListVisibleAtom, storyHomePageJumpAtom, storyImagesMap, storyImagesMapAtom } from "../../../../store";
import story_youtube from '../../assets/story_youtube.png'
import story_twitter from '../../assets/story_twitter.png'
import story_bilibili from '../../assets/story_bilibili.png'
import story_xiaohongshu from '../../assets/story_xiaohongshu.png'
import story_pinterest from '../../assets/story_pinterest_small.png'
import story_reddit from '../../assets/story_reddit.png'
import story_ins from '../../assets/story_ins.png'
import { MiniStoryPost, StoryPost } from '../StoryPost';
import StoryTags from './tags';
import { getStoriesInPublicGallery, getStoryLikedList, storyLikeOperation } from '../../../../utils/net';
import { AvatarImage } from '../../../../common/AvatarImage';
import { formatDescription } from '../../../../utils/format';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Vector from '../../assets/Vector.png'
import styles from '@/common/ScrollLoader/scrollloader.module.css';
import { useDebounce } from '../../../../utils/hooks';
import { motion } from 'framer-motion';

import { ErrorPage } from "../../../../components/ErrorPage";
import * as Sentry from "@sentry/react";

const STORY_MEDIA_MAP = [
  { type: 'YouTube', icon: story_youtube, permission: true, followUrl: 'https://www.youtube.com/' },
  { type: 'X', icon: story_twitter, permission: true, followUrl: 'https://x.com/' },
  { type: 'Twitter', icon: story_twitter, permission: true, followUrl: 'https://x.com/' },
  { type: 'Bilibili', icon: story_bilibili, permission: true, followUrl: 'https://space.bilibili.com/' },
  { type: 'Xiaohongshu', icon: story_xiaohongshu, permission: true, followUrl: 'https://www.xiaohongshu.com/' },
  { type: 'Reddit', icon: story_reddit, permission: true, followUrl: 'https://www.reddit.com/' },
  { type: 'Ins', icon: story_ins, permission: true, followUrl: 'https://www.instagram.com/' },
]
const StoryComponent = (props) => {
  const { type = 'normal', handleHomePageJump } = props;
  const [error, setError] = useState(null);
  const storyTags = useRecoilValue(storyTagsAtom);
  const [storyList, setStoryList] = useRecoilState(storyListAtom);
  const [storiesLoaded, setStoriesLoaded] = useRecoilState(storiesLoadedAtom);
  const [loading, setLoading] = useState(true);
  const [visibleStories, setVisibleStories] = useRecoilState(storyListVisibleAtom);
  const observerRef = useRef(null);
  const loadingRef = useRef(null);
  const [storyHomePageJump, setStoryHomePageJump] = useRecoilState(storyHomePageJumpAtom);
  const scrollContainerRef = useRef(null);
  const [storyImagesMap, setStoryImagesMap] = useRecoilState(storyImagesMapAtom);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const storyEmbedRef = useRef(null);
  const logInfo = useRecoilValue(logInfoAtom);
  const setLikedStoryIds = useSetRecoilState(likedStoryIdsAtom);

  const getImageUrl = (item) => {
    if (item.tosImgUrls?.length) {
      return item.tosImgUrls
    }
    return [item.thumbnailUrl || item.videolUrl]
  }

  const fetchPublicStories = useDebounce(async (storyTags) => {
    try {
      setLoading(true);
      setIsTransitioning(true);  // 开始加载时设置过渡状态

      // 添加一个短暂延迟让过渡效果更明显
      await new Promise(resolve => setTimeout(resolve, 300));

      const publicStories = await getStoriesInPublicGallery({
        access_token: null,
        status: 'Approved',
        tagNames: [...storyTags],
        includeLikedStoryIds: true
      });

      if (publicStories?.storyList?.length > 0) {
        setStoryList(publicStories.storyList);

        if (storyImagesMap.firstRender) {
          setStoryImagesMap({
            firstRender: false,
            imagesMap: publicStories.storyList.reduce((acc, item) => {
              acc[item.id] = getImageUrl(item);
              return acc;
            }, {})
          })
        }

        setVisibleStories(publicStories.storyList.slice(0, type === 'mini' ? 6 : 3));
        setStoriesLoaded(true); // 标记数据已加载
      }
    } catch (err) {
      setError(err);
      Sentry.captureMessage(err)
    } finally {
      setLoading(false);
      // 使用setTimeout让过渡效果更平滑
      setTimeout(() => {
        setIsTransitioning(false);
      }, 300);
    }
  }, 300)

  const fetchStoryLikedList = async () => {
    const likedList = await getStoryLikedList();
    // 兼容处理：将对象数组或纯 id 数组统一转换为纯 id 数组
    const ids = likedList.map(item => (item && item.id ? item.id : item));
    setLikedStoryIds(ids);

  }

  useEffect(() => {
    if (logInfo?.user_uuid && !storyHomePageJump) {
      fetchStoryLikedList();
    }
  }, [logInfo]);


  useEffect(() => {
    // 只在数据未加载或标签变化时获取数据
    if (!storiesLoaded || storyTags.length > 0) {
      fetchPublicStories(storyTags);
    } else if (storyList.length > 0) {
      // 如果数据已存在，直接设置可见故事
      setVisibleStories(storyList.slice(0, type === 'mini' ? 6 : 3));
      setLoading(false);
    }
  }, [storyTags, storiesLoaded]);

  useEffect(() => {
    if (storyHomePageJump) {
      setVisibleStories(currentVisibleStories => {
        const targetIndex = storyList.findIndex(s => s.id === storyHomePageJump);
        if (targetIndex > -1) {
          return storyList.slice(0, targetIndex + 1);
        }
        return currentVisibleStories;
      });

      setTimeout(() => {
        const storyElement = document.getElementById(`story-${storyHomePageJump}`);

        if (storyElement) {
          storyElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          setTimeout(() => {
            storyElement.classList.add(style.flashAnimation);
            setTimeout(() => {
              storyElement.classList.remove(style.flashAnimation);
              setStoryHomePageJump(false)
            }, 1500);
          }, 500);
        }
      }, 1000);
    }
  }, [storyHomePageJump]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && storyList.length > visibleStories.length) {
          const currentLength = visibleStories.length;
          const nextStories = storyList.slice(
            currentLength,
            currentLength + (type === 'mini' ? 6 : 3)
          );
          setVisibleStories(prev => [...prev, ...nextStories]);
        }
      },
      {
        root: type === 'mini' ? scrollContainerRef.current : null,
        rootMargin: type === 'mini' ? '200px' : '100px',
        threshold: 0.05
      }
    );

    if (loadingRef.current) {
      observer.observe(loadingRef.current);
    }

    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [storyList, visibleStories]);


  const renderContent = (displayType, handleHomePageJump) => {

    if (loading && !visibleStories.length) {
      return new Array(3).fill(1).map((_, index) => (
        <LoadingEmbed key={index} />
      ));
    }

    if (!storyList?.length) {
      return (
        <div className='w-full h-[300px] flex flex-col items-center justify-center bg-[rgba(255,255,255,0.05)] rounded-[24px]'>
          <p className='text-[rgba(153,153,153,1)] text-[16px]'>No stories found</p>
          <p className='[background-image:linear-gradient(90deg,#E9B664_44.89%,#8C76F0_92.99%)] text-transparent bg-clip-text font-bold text-[18px] animate-pulse cursor-pointer hover:scale-105 transition-all duration-300'>
            Share the link now to participate!
          </p>
        </div>
      );
    }

    return (
      <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => (
              <ErrorPage
                  errorMessage={error?.message}
                  resetError={resetError}
              />
          )}>
        <motion.div
          ref={scrollContainerRef}
          className={`w-full flex flex-col gap-[16px] ${displayType === 'mini' ? 'overflow-scroll h-[70vh]' : ''}`}
          initial={{ opacity: 1 }}
          animate={{
            opacity: isTransitioning ? 0.5 : 1,
            scale: isTransitioning ? 0.98 : 1,
          }}
          transition={{ duration: 0.2 }}
        >
          {visibleStories.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ y: 5 }}
              animate={{ y: 0 }}
              transition={{ duration: 0.1, delay: index * 0.05 }}
            >
              <StoryEmbed
                ref={storyEmbedRef}
                option={item}
                key={index}
                displayType={displayType}
                handleHomePageJump={handleHomePageJump} />
            </motion.div>
          ))}
          {storyList.length > visibleStories.length && (
            <div ref={loadingRef} className="py-4">
              <div className={styles.scanner}>
                <span>Loading...</span>
              </div>
            </div>
          )}
          {storyList.length === visibleStories.length && (
            <div className="py-4 text-center text-gray-400">
              That&apos;s all stories
            </div>
          )}
        </motion.div>
      </Sentry.ErrorBoundary>
    );
  };

  const StoryType = {
    'mini': (
      <div className='w-full min-h-[200px] flex gap-[12px] flex-col max-w-[500px] xs:max-w-[600px] sm:max-w-[800px] md:max-w-[1000px]'>
        <MiniStoryPost handleHomePageJump={handleHomePageJump} />
        <div className="bg-[rgba(0,0,0,0.2)] rounded-[24px] p-5 flex flex-col gap-[12px]">
          <h3 className="text-[rgba(255,255,255,0.3)] text-[20px] font-bold text-left">STORY</h3>
          <StoryTags setError={setError} setLoading={setLoading} setVisibleStories={setVisibleStories} displayType={type} />
          {renderContent(type, handleHomePageJump)}
        </div>
      </div>
    ),
    'normal': (
      <div className='will-change-transform w-full h-full min-h-[200px] flex gap-[20px] flex-col max-w-[500px] xs:max-w-[600px] sm:max-w-[800px] md:max-w-[1000px]'>
        <StoryPost />
        <StoryTags setError={setError} setLoading={setLoading} setVisibleStories={setVisibleStories} />
        <div className='flex flex-col gap-[20px]'>
          {renderContent(type)}
        </div>
      </div>
    )
  }

  return StoryType[type];
};

const LoadingEmbed = () => {
  return (
    <div className="w-full h-full p-[20px_20px_16px_20px] bg-[rgba(255,255,255,0.05)] backdrop-blur-sm rounded-[24px] text-left animate-pulse">
      <div className="flex justify-between">
        <div className="flex gap-2">
          <div className="rounded-full w-[40px] h-[40px] bg-[rgba(255,255,255,0.1)]"></div>
          <div className="flex flex-col">
            <span className="w-20 h-4 bg-[rgba(255,255,255,0.1)] rounded"></span>
            <span className="w-24 h-3 mt-1 bg-[rgba(255,255,255,0.1)] rounded"></span>
          </div>
        </div>
      </div>
      <h3 className="w-3/4 h-6 my-[8px] bg-[rgba(255,255,255,0.1)] rounded"></h3>
      <p className="w-full h-8 bg-[rgba(255,255,255,0.1)] rounded"></p>
      <div className={`rounded-[20px] overflow-hidden mt-[8px] bg-[rgba(255,255,255,0.1)] p-[4px] h-[200px]`}>
        <div className="w-full h-full bg-[rgba(255,255,255,0.1)] rounded-[16px]"></div>
      </div>
    </div>
  );
}

const StoryEmbed = React.forwardRef(({ option, displayType, handleHomePageJump }, ref) => {
  const {
    authorAvatar,
    videoTitle,
    videoDescription,
    thumbnailUrl,
    authorName,
    url,
    authorUrl,
    formattedDate,
    videolUrl,
    type,
    authorEmail,
    imgUrls,
    tosImgUrls,
    num_like,
    id
  } = option;

  const [likedStoryIds, setLikedStoryIds] = useRecoilState(likedStoryIdsAtom);
  const setStoryList = useSetRecoilState(storyListAtom);
  const isLiked = likedStoryIds.includes(option.id) || likedStoryIds.find(item => item.id === option.id);
  const [isCopied, setIsCopied] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const likeTimeoutRef = useRef(null);
  const setVisibleStories = useSetRecoilState(storyListVisibleAtom);

  const handleCopyLink = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 1500);
    } catch (error) {
      Sentry.captureException(error)
      tip({
        type: 'error',
        presetText: 'ERROR',
        content: 'Failed to copy text.',
      });
    }
  };

  const mediaIcon = STORY_MEDIA_MAP.find(item => item.type === type || url.includes(item.followUrl))?.icon;
  const calcType = STORY_MEDIA_MAP.find(item => item.type === type || url.includes(item.followUrl))?.type;
  const isYoutube = calcType === 'YouTube';
  const isTwitter = calcType === 'Twitter';
  const isReddit = calcType === 'Reddit';
  const getImageUrl = () => {
    if (tosImgUrls?.length) {
      return tosImgUrls
    }
    return [thumbnailUrl || videolUrl]
  }

  useImperativeHandle(ref, () => ({
    handleLikeByID: handleLikeByID,
  }))

  const handleLikeByID = (likeid) => {
    if (!logInfo) {
      setShowLogin(true);
      return;
    }
    if (id === likeid) {
      if (isLiked) return
      handleLike()
    }
  }


  const toggleExpand = (e) => {
    const isClickableElement = e.target.closest('a') ||
      e.target.closest('img') ||
      e.target.closest('[onClick]') ||
      e.target.closest('.swiper-container');

    if (!isClickableElement && isTruncated) {
      e.preventDefault();
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    }
    if (displayType === 'mini') {
      handleLike(undefined, true)
      handleHomePageJump(option, e)
    } else {
      handleLike(undefined, true)
    }
  };

  const [isTruncated, setIsTruncated] = useState(false);
  const [isExpandedTruncated, setIsExpandedTruncated] = useState(false);
  const logInfo = useRecoilValue(logInfoAtom);
  const setShowLogin = useSetRecoilState(showLoginAtom);
  const textRef = useRef(null);
  const maxLines = isTwitter ? 4 : 2;
  const maxExpandedLines = isTwitter ? 6 : 5;
  const lineHeight = 24;

  // 检查文本是否需要截断
  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const maxHeight = lineHeight * maxLines;
      setIsTruncated(element.scrollHeight > maxHeight);
    }
  }, [videoDescription, maxLines]);

  useEffect(() => {
    if (isExpanded && textRef.current) {
      const element = textRef.current;
      const maxHeight = lineHeight * maxExpandedLines;
      setIsExpandedTruncated(element.scrollHeight > maxHeight);
    }
  }, [isExpanded]);

  // 获取截断后的文本
  const getTruncatedText = () => {
    if (!videoDescription) return '';

    if (!isExpanded && isTruncated) {
      const element = textRef.current;
      const style = window.getComputedStyle(element);
      const lineHeight = parseInt(style.lineHeight);
      const maxHeight = lineHeight * maxLines;

      // 考虑省略号的空间，减少一些宽度用于显示省略号
      const measureDiv = document.createElement('div');
      measureDiv.style.cssText = `
            position: absolute;
            width: ${element.offsetWidth - 30}px; // 预留省略号空间
            visibility: hidden;
            white-space: pre-wrap;
            word-break: break-word;
            overflow-wrap: break-word;
            font-size: ${style.fontSize};
            font-family: ${style.fontFamily};
            line-height: ${style.lineHeight};
        `;
      document.body.appendChild(measureDiv);

      // 二分查找合适的文本长度
      let start = 0;
      let end = videoDescription.length;
      let result = '';

      while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        const testText = videoDescription.substring(0, mid);
        measureDiv.textContent = testText;

        if (measureDiv.offsetHeight <= maxHeight) {
          result = testText;
          start = mid + 1;
        } else {
          end = mid - 1;
        }
      }

      document.body.removeChild(measureDiv);

      // 保截断在单词或表情符号边界
      if (result.length < videoDescription.length) {
        let cutIndex = result.length;
        while (cutIndex > 0) {
          const char = videoDescription[cutIndex - 1];
          const nextChar = videoDescription[cutIndex];
          if (
            char === ' ' ||
            char === '\n' ||
            /\s/.test(char) ||
            (char.match(/[\uD800-\uDBFF]/) && nextChar.match(/[\uDC00-\uDFFF]/))
          ) {
            break;
          }
          cutIndex--;
        }
        result = videoDescription.substring(0, cutIndex);
      }

      return formatDescription(result);
    }
    return formatDescription(videoDescription);
  };

  const handleLike = async (e, likeOnly = false) => {
    e?.stopPropagation();
    if (!logInfo) {
      setShowLogin(true);
      return;
    }

    // 如果是仅点赞模式且已经点赞，直接返回
    if (likeOnly && isLiked) return;

    // 更新 UI 状态
    const newIsLiked = !isLiked;
    setLikedStoryIds(prev => (newIsLiked ? [...prev, option.id] : prev.filter(id => id !== option.id)));
    setStoryList(prev => prev.map(story => story.id === option.id ? { ...story, num_like: story.num_like + (newIsLiked ? 1 : -1) } : story));
    setVisibleStories(prev => prev.map(story => story.id === option.id ? { ...story, num_like: story.num_like + (newIsLiked ? 1 : -1) } : story));

    // 防抖处理 API 请求
    if (likeTimeoutRef.current) {
      clearTimeout(likeTimeoutRef.current);
    }

    likeTimeoutRef.current = setTimeout(async () => {
      try {
        // 直接发送最后一次点击的 API 请求
        await storyLikeOperation(option.id, newIsLiked ? 'Like' : 'Delike');
      } catch (error) {
        console.error('点赞操作失败:', error);
        Sentry.captureException(error)
        // 发生错误时回滚 UI 状态
        if (newIsLiked) {
          setLikedStoryIds(prev => prev.filter(id => id !== option.id));
        } else {
          setLikedStoryIds(prev => [...prev, option.id]);
        }

        const updateStoryLikes = (stories) => stories.map(story => {
          if (story.id === option.id) {
            return {
              ...story,
              num_like: story.num_like + (newIsLiked ? -1 : 1)
            };
          }
          return story;
        });

        setStoryList(updateStoryLikes);
        setVisibleStories(updateStoryLikes);
      }
    }, 300); // 300ms 的防抖延迟
  };

  // 组件卸载时清理定时器
  useEffect(() => {
    return () => {
      if (likeTimeoutRef.current) {
        clearTimeout(likeTimeoutRef.current);
      }
    };
  }, []);

  const memoizedImageSlider = useMemo(() => {
    return <ImageSlider images={getImageUrl()} url={url} isMini={displayType === 'mini'} id={id} />
  }, [getImageUrl(), url, displayType])

  const StoryEmbedType = {
    'mini': (
      <div className={`w-full backdrop-blur-sm text-left p-[12px_8px] [border-bottom:1px_solid_rgba(255,255,255,0.1)]  transition-300-ease`}
        onClick={toggleExpand}>
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <div className="rounded-full w-[32px] h-[32px] overflow-hidden">
              <AvatarImage width='100%' height='100%' noReferrer={!isYoutube} url={authorAvatar || ''} />
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-[12px] text-white h-[20px]">{authorName || "Unknown User"}</span>
            </div>
          </div>
          <div className={`h-[16px] ${isReddit ? 'h-[20px]' : ''}`}>
            <img className="h-full" src={mediaIcon} alt={type} />
          </div>
        </div>
        <div className="group">
          <h3 className="text-[16px] my-[8px] text-[rgba(255,255,255,1)]">{videoTitle}</h3>
          <div className="relative">
            <div
              className="text-[14px] text-[rgba(170,170,170,1)] max-w-full line-clamp-3"
              style={{
                wordBreak: 'keep-all',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap'
              }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: formatDescription(videoDescription)
                }}
              />
            </div>
          </div>
          <div className="flex justify-center items-center">
            {memoizedImageSlider}
          </div>
          <div className="flex justify-between items-center max-w-[292px] pl-[8px]">
            <div
              onClick={handleLike}
              className="flex items-center gap-1 cursor-pointer min-w-[40px] group/like"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-all duration-200 ${!isLiked && 'group-hover/like:scale-110'}`}
              >
                <path
                  d="M13.1137 4.2666C12.473 4.2666 11.8241 4.41326 11.2372 4.69073C10.7824 4.90577 10.362 5.20037 10.0037 5.55335C9.64543 5.20037 9.22505 4.90575 8.77024 4.69071C8.1834 4.41326 7.53454 4.2666 6.89378 4.2666C5.76156 4.2666 4.71113 4.69459 3.93598 5.47176C3.16111 6.24864 2.73438 7.30126 2.73438 8.43572C2.73438 11.1911 5.07445 13.3316 8.61657 16.5718L8.75963 16.7027L10.0037 17.8211L10.2474 17.602L11.2455 16.7048L11.3906 16.5721C14.9329 13.3318 17.2731 11.1911 17.2731 8.43572C17.2731 7.30126 16.8464 6.24866 16.0715 5.47176C15.2963 4.69461 14.2459 4.2666 13.1137 4.2666Z"
                  fill={isLiked ? "#F91880" : "transparent"}
                  stroke={isLiked ? "#F91880" : "#999999"}
                  className={`transition-colors duration-200 ${!isLiked && 'group-hover/like:stroke-white'}`}
                />
              </svg>
              {num_like > 0 && (
                <span className={`text-sm ${isLiked ? 'text-[#F91880]' : 'text-[#999999]'}`}>
                  {num_like}
                </span>
              )}
            </div>
            <span
              onClick={handleCopyLink}
              className="text-[rgba(153,153,153,1)] text-[12px] font-bold cursor-pointer bg-[rgba(255,255,255,0.05)] rounded-[200px] p-[5px_16px] transition-300-ease hover:bg-[rgba(29,155,240,0.15)] hover:text-[rgba(29,155,240,1)]"
            >
              {isCopied ? 'Copied!' : 'Copy link'}
            </span>
          </div>
        </div>
      </div>
    ),
    'normal': (
      <div
        id={`story-${id}`}
        className="w-full p-[20px_20px_16px_20px] bg-[rgba(255,255,255,0.05)] backdrop-blur-sm rounded-[24px] text-left"
        onClick={toggleExpand}>
        <div className="flex justify-between">
          <div className="flex gap-2">
            <div className="rounded-full w-[40px] h-[40px] overflow-hidden">
              <AvatarImage width='100%' height='100%' noReferrer={!isYoutube} url={authorAvatar || ''} />
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-[14px] text-white h-[20px]">{authorName || "Unknown User"}</span>
            </div>
          </div>
          <div className={`h-[20px] ${isReddit ? 'h-[24px]' : ''}`}>
            <img className="h-full" src={mediaIcon} alt={type} />
          </div>
        </div>
        <div className="px-[50px] group">
          <h3 className="text-[18px] my-[8px] text-[rgba(255,255,255,1)]">{videoTitle}</h3>
          <div className="relative">
            <div
              ref={textRef}
              className={`text-[16px] text-[rgba(170,170,170,1)] max-w-full ${isYoutube ? 'whitespace-pre-line' : ''
                }`}
              style={{
                maxHeight: (!isExpanded && isTruncated)
                  ? `${lineHeight * maxLines}px`
                  : `${lineHeight * maxExpandedLines}px`,
                overflow: 'hidden',
                transition: 'max-height 300ms ease',
                wordBreak: 'keep-all',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap'
              }}
            >
              <span className="max-w-full inline-block">
                <span
                  dangerouslySetInnerHTML={{
                    __html: getTruncatedText()
                  }}
                />
                {isExpanded && isExpandedTruncated && (
                  <span className="inline-flex items-center">...</span>
                )}
              </span>
            </div>
            {isTruncated && (
              <div
                className="text-[12px] text-[#1d9bf0] hover:text-[#1d9bf0]/80 font-medium mt-2 cursor-pointer transition-colors duration-200"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsExpanded(!isExpanded);
                }}
              >
                {isExpanded ? 'Show less' : (
                  <>
                    Show more &nbsp;
                    <span className="inline-flex items-center font-bold text-white group-hover:animate-pulse cursor-pointer">
                      <span className="inline-block transition-all duration-300 group-hover:translate-x-[2px]">.</span>
                      <span className="inline-block transition-all duration-300 group-hover:translate-x-[4px] delay-75">.</span>
                      <span className="inline-block transition-all duration-300 group-hover:translate-x-[6px] delay-100">.</span>
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="flex justify-center items-center">
            {memoizedImageSlider}
          </div>
          <div className="flex justify-between items-center max-w-[292px] pl-[8px]">
            <div
              onClick={handleLike}
              className="flex items-center gap-1 cursor-pointer min-w-[40px] group/like"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-all duration-200 ${!isLiked && 'group-hover/like:scale-110'}`}
              >
                <path
                  d="M13.1137 4.2666C12.473 4.2666 11.8241 4.41326 11.2372 4.69073C10.7824 4.90577 10.362 5.20037 10.0037 5.55335C9.64543 5.20037 9.22505 4.90575 8.77024 4.69071C8.1834 4.41326 7.53454 4.2666 6.89378 4.2666C5.76156 4.2666 4.71113 4.69459 3.93598 5.47176C3.16111 6.24864 2.73438 7.30126 2.73438 8.43572C2.73438 11.1911 5.07445 13.3316 8.61657 16.5718L8.75963 16.7027L10.0037 17.8211L10.2474 17.602L11.2455 16.7048L11.3906 16.5721C14.9329 13.3318 17.2731 11.1911 17.2731 8.43572C17.2731 7.30126 16.8464 6.24866 16.0715 5.47176C15.2963 4.69461 14.2459 4.2666 13.1137 4.2666Z"
                  fill={isLiked ? "#F91880" : "transparent"}
                  stroke={isLiked ? "#F91880" : "#999999"}
                  className={`transition-colors duration-200 ${!isLiked && 'group-hover/like:stroke-white'}`}
                />
              </svg>
              {num_like > 0 && (
                <span className={`text-sm ${isLiked ? 'text-[#F91880]' : 'text-[#999999]'}`}>
                  {num_like}
                </span>
              )}
            </div>
            <span
              onClick={handleCopyLink}
              className="text-[rgba(153,153,153,1)] text-[12px] font-bold cursor-pointer bg-[rgba(255,255,255,0.05)] rounded-[200px] p-[5px_16px] transition-300-ease hover:bg-[rgba(29,155,240,0.15)] hover:text-[rgba(29,155,240,1)]"
            >
              {isCopied ? 'Copied!' : 'Copy link'}
            </span>
          </div>
        </div>
      </div>
    )
  }

  return StoryEmbedType[displayType];
});

const customStyles = `
  .swiper-scrollbar {
    bottom: 0;
    height: 5px;
  }
  .swiper-scrollbar-drag {
    background: rgba(255,255,255,0.2);
    height: 5px;
  }
`;

const ImageSlider = (props) => {
  const { images, url, isMini, id } = props
  const isSingleImage = images.length === 1;
  const [isDragging, setIsDragging] = useState(false);
  const isBilibili = url?.includes('bilibili.com');
  const isYoutube = url?.includes('youtube.com');
  const swiperRef = useRef(null);
  const storyImagesMap = useRecoilValue(storyImagesMapAtom);


  useEffect(() => {
    const updateMousewheelState = () => {
      if (swiperRef.current?.swiper) {
        const swiper = swiperRef.current.swiper;
        const windowWidth = window.innerWidth;

        // 根据断点判断当前应该显示几张图片
        let currentSlidesPerView = 1;
        if (windowWidth >= 1200) {
          currentSlidesPerView = 3;
        } else if (windowWidth >= 900) {
          currentSlidesPerView = 2;
        }

        const isAllSlidesVisible = images.length <= currentSlidesPerView;

        if (isAllSlidesVisible) {
          swiper.mousewheel.disable();
          swiper.el.removeEventListener('wheel', swiper.mousewheel.handle);
        } else {
          swiper.mousewheel.enable();
        }
      }
    };

    updateMousewheelState();
    window.addEventListener('resize', updateMousewheelState);
    return () => window.removeEventListener('resize', updateMousewheelState);
  }, [images]);

  const handleMouseDown = (e) => {
    const startX = e.clientX;

    const handleMouseMove = (e) => {
      const endX = e.clientX;
      if (Math.abs(endX - startX) > 50) {
        setIsDragging(true);
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    setIsDragging(false);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleClick = (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  };

  const renderImage = (image, index) => {
    return (
      <div className="relative group">
        <img
          src={image}
          alt={`slide-${index}`}
          className="w-full max-w-[400px] object-cover overflow-hidden aspect-[4/3] rounded-md select-none"
        />
        {(isBilibili || isYoutube) && (
          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-300-ease flex items-center justify-center">
            <img
              src={Vector}
              alt="play"
              className="w-12 h-12 transition-300-ease hover:scale-110"
            />
          </div>
        )}
      </div>
    );
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    window.open(url, '_blank');
  };

  const getImageUrls = (id) => {
    return storyImagesMap.imagesMap[id]
  }

  return (
    <>
      <style>{customStyles}</style>
      <div className={`w-full max-w-[1200px] ${isMini ? 'py-2' : 'p-2'} ${isSingleImage ? '' : 'pl-0'}`}>
        {isSingleImage ? (
          <div onClick={handleImageClick} className="max-w-[300px] text-base font-medium text-white bg-[rgba(255,255,255,0.4)] rounded-lg p-1 cursor-pointer">
            {renderImage(getImageUrls(id)[0], 0)}
          </div>
        ) : (
          <Swiper
            ref={swiperRef}
            modules={[Scrollbar, Mousewheel]}
            grabCursor={true}
            speed={400}
            mousewheel={{
              invert: false,
            }}
            scrollbar={{
              hide: false,
              draggable: true,
            }}
            slidesPerView={1}
            spaceBetween={10}
            breakpoints={{
              900: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            className="w-full"
          >
            {getImageUrls(id).map((image, index) => (
              <SwiperSlide key={index}>
                <a href={url} target="_blank" rel="noreferrer" onClick={handleClick}>
                  <div
                    className="max-w-[400px] text-base font-medium text-white bg-[rgba(255,255,255,0.4)] rounded-lg p-1 cursor-pointer"
                    onMouseDown={handleMouseDown}
                  >
                    {renderImage(image, index)}
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </>
  );
}


StoryEmbed.displayName = 'StoryEmbed';
export default React.memo(StoryComponent);


